import React from 'react';

interface SyndicationIconProps {
  height?: number;
  width?: number;
  color?: string;
}

const SyndicationIcon: React.FC<SyndicationIconProps> = ({ height, width, color = '#FFDAB9' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 500 500"
      width={`${width}pt`}
      height={`${height}pt`}
    >
      <path
        style={{ fill: color }}
        d="M273 270.45a21.6 21.6 0 0 1-7.57 7.78A26.4 26.4 0 0 1 253.6 282v8.52h-6.83V282q-9.89-.94-16-6.2a17.39 17.39 0 0 1-6.1-13.87h12.82a11.44 11.44 0 0 0 2.63 6.78 10.82 10.82 0 0 0 6.62 3.41V249a84 84 0 0 1-11.45-3.63 18.3 18.3 0 0 1-7.52-5.83q-3.11-4-3.1-10.93a19 19 0 0 1 6.1-14.45q6.09-5.73 16-6.68V199h6.83v8.51q9.25.84 14.88 5.84t6.36 13.65H262a10.32 10.32 0 0 0-2.52-5.83 11.13 11.13 0 0 0-5.89-3.52v22.7a77.5 77.5 0 0 1 11.46 3.52 18.23 18.23 0 0 1 7.46 5.78q3 3.94 3.05 10.88a20 20 0 0 1-2.56 9.92m-33.53-35.73a18.6 18.6 0 0 0 7.3 3.88v-21.23a11.62 11.62 0 0 0-7.2 3.26 10.1 10.1 0 0 0-2.68 7.36 8.8 8.8 0 0 0 2.58 6.73m21.39 33.68a10.52 10.52 0 0 0 2.62-7.2 8.47 8.47 0 0 0-2.57-6.57 19.1 19.1 0 0 0-7.31-3.83v21.33a11.73 11.73 0 0 0 7.26-3.73"
      ></path>
      <path
        style={{ fill: color }}
        d="M250.13 312a66.43 66.43 0 1 1 66.44-66.43A66.5 66.5 0 0 1 250.13 312m0-122.86a56.43 56.43 0 1 0 56.44 56.43 56.49 56.49 0 0 0-56.44-56.47Z"
      ></path>
      <path
        style={{ fill: color }}
        d="M495.68 149.59a6.41 6.41 0 0 1-2.47 5.08L346 270l-.33.24a7.48 7.48 0 0 1-11.61-6.24v-67.17h-21.92a78.4 78.4 0 0 0-9.37-10h36.29a5 5 0 0 1 5 5v66.95l139.42-109.19-139.42-109.2v64.49a7.48 7.48 0 0 1-7.47 7.47H142.23a79.56 79.56 0 0 0-79.48 79.48v36.31a5 5 0 0 1-10 0v-36.31a89.58 89.58 0 0 1 89.48-89.48h191.83V35.19A7.47 7.47 0 0 1 345.65 29l.33.23L493.21 144.5a6.44 6.44 0 0 1 2.47 5.09"
      ></path>
      <path
        style={{ fill: color }}
        d="M95 204.53a5 5 0 0 1-5-5v-13.91a45.13 45.13 0 0 1 45.08-45.07h100.3a5 5 0 0 1 0 10H135.09A35.12 35.12 0 0 0 100 185.62v13.91a5 5 0 0 1-5 5M95 250.13a5 5 0 0 1-5-5v-23.85a5 5 0 0 1 10 0v23.85a5 5 0 0 1-5 5M447.26 271.86v36.31a89.59 89.59 0 0 1-89.49 89.48H166v67.16a7.48 7.48 0 0 1-7.48 7.47 7.4 7.4 0 0 1-4.11-1.24l-.33-.23L6.8 355.5a6.45 6.45 0 0 1 0-10.17L154 230a3 3 0 0 1 .33-.24A7.48 7.48 0 0 1 166 236v67.15h30.4a78.7 78.7 0 0 0 13.28 10H161a5 5 0 0 1-5-5v-67L16.53 350.41 156 459.61v-64.49a7.48 7.48 0 0 1 7.47-7.47h194.3a79.57 79.57 0 0 0 79.49-79.48v-36.31a5 5 0 0 1 10 0"
      ></path>
      <path
        style={{ fill: color }}
        d="M364.91 359.45h-100.3a5 5 0 0 1 0-10h100.3A35.12 35.12 0 0 0 400 314.38v-13.91a5 5 0 0 1 10 0v13.91a45.13 45.13 0 0 1-45.09 45.07M405 283.72a5 5 0 0 1-5-5v-23.85a5 5 0 0 1 10 0v23.85a5 5 0 0 1-5 5"
      ></path>
    </svg>
  );
};

export default SyndicationIcon;
